export { default } from './TravelQuickTips';
